import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface Document {
  name?: string;
  mimeType?: string;
  size?: number;
}

@Component({
  selector: 'mapfre-document-item',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.scss']
})
export class DocumentComponent {
  @Input() document: Document;
  @Input() documentIconUrl = '';
  @Input() showDocumentSize = true;
  @Input() showButtonDelete = false;
  @Input() showButtonDownload = false;

  @Output() action = new EventEmitter<any[]>();
  @Output() delete = new EventEmitter<any[]>();
  @Output() download = new EventEmitter<any[]>();

  constructor() {}

  onDocumentClick() {
    this.action.emit();
  }

  onDocumentDelete() {
    this.delete.emit();
  }

  onDocumentDownload() {
    this.download.emit();
  }

  documentIconByMimeType() : string {
    if (!this.document.mimeType) {
      return 'assets/images/document.svg';
    }
    const type = this.document.mimeType.split('/')[0];
    const extension = this.document.mimeType.split('/')[1];
    if (extension === 'pdf') {
      return 'assets/images/pdf-icon.svg';
    }
    if (type === 'application') {
      return 'assets/images/document-icon.svg';
    }
    if (type === 'image') {
      return 'assets/images/image-icon.svg';
    }
  }
}
